// The ICON PLATE of a home widget header (HOME_WIDGETS_SPEC.md §2): a 32 px
// squircle (`iconXl`, `radiusControl`) filled with the widget hue, the glyph
// `iconSm` in the hue's measured ink. Opaque by design — it is the one place
// the hue meets the header. The frame publishes `--home-widget-hue` /
// `--home-widget-hue-ink` on the card (pages/main.js), so the plate reads the
// same colour in the shell and inside a module body.
//
// THIS PAIR IS THE PLATE CONTRACT AND ONLY THE PLATE'S (the squircle here, the
// avatar faces in HomeWidgetAvatars): a background with the ink that reads ON
// it. A visual drawn on the CARD surface — a bar, a fill, a spark, a dot, a
// stat — reads `--home-widget-accent` instead, which the frame derives against
// the card's own surface per theme. Reading the plate there is what made a dark
// plate family invisible (HOME-WIDGET-ACCENT-DARK-PLATE-INVISIBLE-1).
//
//   HomeWidgetPlate: { Icon: { name: 'people' } }
export const HomeWidgetPlate = {
  class: 'widget-header-icon',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSize: 'iconXl',
  minWidth: 'iconXl',
  flexShrink: '0',
  round: 'radiusControl',
  background: '--home-widget-hue',
  color: '--home-widget-hue-ink',
  Icon: { boxSize: 'iconSm' }
}
